<script>
import ResultDisplay from "@homepage/components/ResultDisplayStyle2.vue";
import Countdown from "@homepage/components/Countdown.vue";
import {generateImageMapFor} from "@homepage/helpers/image";
import PrizesList from "@homepage/components/PrizesList.vue";
import CurrentTimeDisplay from "@homepage/components/CurrentTimeDisplay.vue";
import LotteryResult from "@homepage/components/LotteryResult.vue";
import LotteryResultAutoDisplay from "@homepage/components/LotteryResultAutoDisplay.vue";
import CardPresenter from "@homepage/components/CardPresenter.vue";

export default {
	name: 'LeslycVipBoard',
	props: {
		generalInformation: {
			type: Object,
			required: true
		}
	},
	components: {
		CardPresenter,
		LotteryResultAutoDisplay,
		LotteryResult,
		CurrentTimeDisplay,
		PrizesList,
		ResultDisplay,
		Countdown
	},
	provide() {
		return {
			imagesMap: generateImageMapFor('quickmoney'),
			generalInformation: this.generalInformation
		};
	},
	data() {
		return {
			timeToShowPrizesPage: 15000,
			timeToShowEachLotteryResultPage: 5000,
			lotteryEntriesPerPage: 3
		};
	},
	computed: {
		timeToShowResultsPage() {
			const timeToShowEachPage = this.timeToShowEachLotteryResultPage / 1000;

			return Math.ceil(this.generalInformation.lotteriesResultsEntries.length / this.lotteryEntriesPerPage) * timeToShowEachPage * 1000;
		}
	}
}
</script>

<template>
	<v-row class="w-100" justify="center" no-gutters>
		<v-col cols="12">
			<v-row>
				<v-col cols="4">
					<v-row>
						<v-col class="main--text">
							<v-card
								v-for="(result, index) in generalInformation.results.slice(1,3)"
								:key="result.sortition.id"
								class="result-card rounded-xl"
								:class="{'mb-7': index !== 1}"
							>
								<result-display
									:result="result"
									:digits-image-dimensions="{height: '35px', width: '35px'}"
									:pick-two-image="{src: require('@/assets/img/leslycvip/pick_2.png'), width: '100%', height: '53px',contain: true}"
									:pick-three-image="{src: require('@/assets/img/leslycvip/pick_3.png'), width: '100%', height: '53px',contain: true}"
									:pick-four-image="{src: require('@/assets/img/leslycvip/pick_4.png'), width: '100%', height: '53px',contain: true}"
									:pick-five-image="{src: require('@/assets/img/leslycvip/pick_5.png'), width: '100%', height: '53px',contain: true}"
								>
								</result-display>
							</v-card>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols="4">
					<v-row class="mt-0" justify='center'>
						<v-col class="px-2 py-1" v-for='sortition in generalInformation.sortedSortitions' cols='auto' :key='sortition.id'>
									<span
										class="draw-text white--text"
										:class='{"yellow--text text-decoration-underline next-drawing-text": generalInformation.sortition.id === sortition.id }'>
										{{ sortition.abbreviation }}
									</span>
						</v-col>
					</v-row>
					<v-row class="mt-0">
						<v-img width="100%" height="150px"
									 contain
									 :src="require('@/assets/img/leslycvip/logo.png')">
						</v-img>
					</v-row>
					<v-row no-gutters>
						<countdown
							id="upcoming-result"
							class="text-center mb-4"
							:sortition="generalInformation.sortition">
							<template #default='{sortition}'>
								<v-flex>
									<span id='next-sortition' class='font-weight-black text-uppercase'>Next draw in</span>
								</v-flex>
								<v-flex>
									<span id='time-left' v-if='sortition.timeLeft'
												class='font-weight-black text-uppercase'>{{ sortition.timeLeft }}
									</span>
									<span v-else>
										<font-awesome-icon icon='sync' spin size='3x'></font-awesome-icon>
									</span>
								</v-flex>
							</template>
						</countdown>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12">
							<v-card
								v-for="result in generalInformation.results.slice(0, 1)"
								:key="result.sortition.id"
								class="result-card rounded-xl"
							>
								<result-display
									:digits-image-dimensions="{height: '40px', width: '40px'}"
									:result="result"
									:pick-two-image="{src: require('@/assets/img/leslycvip/pick_2.png'), width: '100%', height: '53px',contain: true}"
									:pick-three-image="{src: require('@/assets/img/leslycvip/pick_3.png'), width: '100%', height: '53px',contain: true}"
									:pick-four-image="{src: require('@/assets/img/leslycvip/pick_4.png'), width: '100%', height: '53px',contain: true}"
									:pick-five-image="{src: require('@/assets/img/leslycvip/pick_5.png'), width: '100%', height: '53px',contain: true}"
								>
								</result-display>
							</v-card>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols="4">
					<v-row id="current-time" class="mt-2">
						<v-col cols="12">
							<font-awesome-icon icon='clock'></font-awesome-icon>
							<current-time-display :general-information='generalInformation'>
							</current-time-display>
						</v-col>
					</v-row>
					<v-row>
						<v-col
							class="rounded-br-xl"
						>
							<card-presenter
								class='px-5'
								:time-per-page='[timeToShowPrizesPage, timeToShowResultsPage]'>
								<template #page-1>
									<v-row>
										<v-col class="d-flex align-center justify-center">
											 <span class="headers">
														PAYOUTS
											 </span>
										</v-col>
									</v-row>
									<prizes-list :general-information='generalInformation'>
									</prizes-list>
								</template>
								<template #page-2>
									<v-card id='lottery-results' rounded='xl'>
										<lottery-result-auto-display
											:general-information='generalInformation'
											:entries-per-page='lotteryEntriesPerPage'
											:time-to-show-each-page='timeToShowEachLotteryResultPage'>
											<template #page='{ entries }'>
												<v-container class='px-0 py-0'>
													<lottery-result v-for='(entry, index) in entries'
																					class='lottery-result'
																					:class="{'rounded-b-xl': index === entries.length - 1}"
																					:show-pick-five='true'
																					:key='entry.name'
																					:lottery='entry'>
														<template #sortition-header='{sortition, icon, date}'>
															<span class='sortition-header'>
																<font-awesome-icon :icon='icon'></font-awesome-icon>
																{{ sortition.name }}: {{ date }}
															</span>
														</template>
													</lottery-result>
												</v-container>
											</template>
										</lottery-result-auto-display>
									</v-card>
								</template>
							</card-presenter>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
			<v-row no-gutters>
			</v-row>
		</v-col>
	</v-row>
</template>

<style scoped lang="scss">
* {
	color: white;
}

.result-card > * {
	color: white;
}

#animated-clock {
	height: 80px;
	width: 100%;
}

.prize-row {
	background-color: rgba(gray, 0.3);
}

::v-deep .prize-item, .v-card.result-card {
	box-shadow: 0 0 10px yellow, 0 0 20px black, 0 0 30px black;
}

::v-deep .prize-item {
	margin: 10px 0;
	background-color: rgba(0, 0, 0, 0.5);
}

.headers {
	text-shadow: 0 0 10px yellow, 0 0 20px black, 0 0 30px black;
	font-size: 2.5rem;
	font-weight: 800;
}

@keyframes glow {
	0% {
		text-shadow: 0 0 50px red, 0 0 20px black, 0 0 30px black;
	}

	50% {
		text-shadow: 0 0 30px yellow, 0 0 20px black, 0 0 30px black;
	}

	100% {
		text-shadow: 0 0 50px red, 0 0 20px black, 0 0 30px black;
	}
}

.text--glow {
	text-shadow: 0 0 30px yellow, 0 0 20px black, 0 0 30px black;

	&.animated {
		animation: glow 1s ease-in-out infinite;
	}
}

#upcoming-result {
	text-shadow: 0 0 10px yellow, 0 0 20px black, 0 0 30px black;
	font-size: 2.5rem;
	font-weight: 800;
	text-align: center;
	border-radius: 10px;
	background: url("../../../assets/img/leslycvip/counterbg2.png") center;
	background-size: cover;
}

#time-left {
	font-weight: bold;
	font-size: 2.6rem;
	text-align: center;
}

.prize-name {
	font-size: 1.8rem;
	font-weight: bold;
}

.prize-amount {
	font-size: 2rem;
	font-weight: bold;
}

#page-url {
	font-size: 1.3rem;
	font-weight: 800;
}

::v-deep .v-card {
	background-color: rgba(0, 0, 0, 0.5);
}

::v-deep .sortition-name {
	font-size: 1.3rem;
	font-weight: bold;
}

:root .row > .col {
	z-index: 1;
}

.yellow--text {
	color: yellow;
}

#current-time {
	text-shadow: 0 0 5px black;
	text-align: center;
	font-size: 2rem;
	font-weight: bold;
}

::v-deep {
	.sortition-header {
		font-weight: bold;
	}

	.prize-name {
		font-size: 1.8rem;
		font-weight: bold;
	}

	.prize-amount {
		font-size: 2rem;
		font-weight: bold;
	}
}

.draw-text {
	font-size: 1.5rem;
	font-weight: bold;
}

.next-drawing-text {
	text-shadow: 0 0 10px yellow, 0 0 20px black, 0 0 30px black;
}
</style>

<style>
#version {
	color: black;
}

#inspire {
	background-image: url("../../../assets/img/leslycvip/background.jpg");
}
</style>
